import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
};

const onRequest = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const onSuccess = state => ({
  ...state,
  isLoading: false,
});

const onFailure = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload,
});

const clearState = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_GENERATE_CODE_REQUEST]: onRequest,
  [actionTypes.FETCH_GENERATE_CODE_SUCCESS]: onSuccess,
  [actionTypes.FETCH_GENERATE_CODE_FAILURE]: onFailure,
  [actionTypes.CLOSE_CODE_MODAL]: clearState,
  [actionTypes.FLUSH_GENERATE_CODE_ERROR]: clearState,
});
